import { ReactFlowInstance } from '@xyflow/react'
import { ProcessFlowDiagramBuilderContext } from 'features/processFlowDiagrams/contexts/ProcessFlowDiagramBuilderContext'
import { PfdEdge, PfdNode } from 'features/processFlowDiagrams/types'
import { useCallback, useContext, useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const useDragLibrary = () => {
  const { setPfd } = useContext(ProcessFlowDiagramBuilderContext)

  const reactFlowWrapper = useRef<HTMLDivElement>(null)
  const [reactFlowInstance, setReactFlowInstance] = useState<ReactFlowInstance<
    PfdNode,
    PfdEdge
  > | null>(null)

  const onDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
  }, [])

  const onDrop = useCallback(
    (event: React.DragEvent) => {
      event.preventDefault()

      const type = event.dataTransfer.getData('application/reactflow')

      if (typeof type === 'undefined' || !type || !reactFlowInstance) {
        return
      }

      const reactFlowBounds = reactFlowWrapper.current?.getBoundingClientRect()
      if (!reactFlowBounds) return

      const position = reactFlowInstance.screenToFlowPosition({
        x: event.clientX - reactFlowBounds.left + 300,
        y: event.clientY - reactFlowBounds.top,
      })

      const newNode: PfdNode = {
        id: `${type}-${uuidv4().slice(0, 8)}`,
        type,
        position,
        data: { label: `New ${type}` },
      }

      setPfd((pfd) => ({
        ...pfd,
        nodes: [...pfd.nodes, newNode],
      }))
    },
    [reactFlowInstance, setPfd]
  )

  const onInit = useCallback(
    (instance: ReactFlowInstance<PfdNode, PfdEdge>) => {
      setReactFlowInstance(instance)
    },
    []
  )

  return {
    onDragOver,
    onDrop,
    onInit,
    reactFlowWrapper,
  }
}
